/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { CurrencyEnum } from '@spectrocoin/sc-currencies';
import Currency from '../../interfaces/Currency';
import MerchantProject from '../../interfaces/MerchantProject';
import { RemoteData, RemoteError, RemoteStatus } from '../SharedTypes';
import { fetchProject, fetchCurrencies } from './PublicFormThunks';

export type PublicForm = {
	receiveAmount: string;
	receiveCurrencyCode: CurrencyEnum | null;
	orderId: string | null;
	description: string | null;
};

type PublicFormState = {
	project: RemoteData<MerchantProject>;
	currency: RemoteData<Currency[]>;
};

const initialState: PublicFormState = {
	project: {
		status: RemoteStatus.None,
	},
	currency: {
		status: RemoteStatus.None,
	},
};

const slice = createSlice({
	initialState,
	name: 'publicForm',
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(fetchProject.pending, (state) => {
				state.project.status = RemoteStatus.InProgress;
				delete state.project.error;
			})
			.addCase(fetchProject.rejected, (state, { payload }) => {
				state.project.status = RemoteStatus.Error;
				state.project.error = payload as RemoteError;
			})
			.addCase(fetchProject.fulfilled, (state, { payload }) => {
				state.project.status = RemoteStatus.Done;
				state.project.data = payload;
			})
			.addCase(fetchCurrencies.pending, (state) => {
				state.currency.status = RemoteStatus.InProgress;
				delete state.currency.error;
			})
			.addCase(fetchCurrencies.rejected, (state, { payload }) => {
				state.currency.status = RemoteStatus.Error;
				state.currency.error = payload as RemoteError;
			})
			.addCase(fetchCurrencies.fulfilled, (state, { payload }) => {
				state.currency.status = RemoteStatus.Done;
				state.currency.data = payload;
			}),
});

export default slice;
